<template>
  <v-dialog v-model="visible" max-width="1200px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" lg="4" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <v-btn
              class="mx-1"
              color="primary"
              title="Registrar"
              small
              :disabled="form.costosProgramaValidado"
              @click="$refs.modalCostosProgramaRef.abrir(accionesCrud.REGISTRAR, [])">
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              class="mx-1"
              title="Editar"
              small
              :disabled="item == null || form.costosProgramaValidado"
              @click="$refs.modalCostosProgramaRef.abrir(accionesCrud.EDITAR, item)">
              <v-icon>mdi-pencil</v-icon>

              Editar
            </v-btn>

            <v-btn
              small
              class="mx-1"
              :disabled="item == null || form.costosProgramaValidado"
              title="Eliminar"
              @click="
                () =>
                  confirmacionAccion(
                    accionesAConfirmar.ELIMINAR,
                    nombreItem,
                    `de ${item.conceptoUniversidad.concepto.nombre} con monto ${item.monto}`,
                  )
              ">
              <v-icon>mdi-close</v-icon>

              Eliminar
            </v-btn>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

            <v-btn
              small
              class="mx-1"
              :disabled="items.length === 0 || validandoCostosPrograma || form.costosProgramaValidado"
              title="Validar Costos Programa"
              @click="confirmarAccionValidarCostosPrograma"
              :loading="validandoCostosPrograma">
              <v-icon>mdi-check</v-icon>

              Validar Costos Programa
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoCostosProgramas ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
          </v-col>
        </v-row>

        <ModalFormularioCostosPrograma
          ref="modalCostosProgramaRef"
          :nombreRecurso="nombreItem"
          :programaUniversidadId="form.id"
          :universidadId="form.sedeUniversidad?.universidadId"
          @actualizarListado="listar" />

        <ConfirmacionAccion
          ref="confirmacionRef"
          :titulo="confirmacion.titulo"
          :mensaje="confirmacion.mensaje"
          :realizandoAccion="confirmacion.realizandoAccion"
          @aceptar="confirmacion.fnAceptar" />
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListadoCostosProgramas from './ListadoCostosProgramas.vue';
import CostoProgramaService from '../services/costo-programa.service';
import ModalFormularioCostosPrograma from './ModalFormularioCostosPrograma.vue';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';

export default {
  name: 'ModalCostosPrograma',
  mixins: [programaUniversidadMixin],
  components: {
    ListadoCostosProgramas,
    ModalFormularioCostosPrograma,
  },
  data() {
    return {
      nombreItem: 'Costo Programa',
      validandoCostosPrograma: false,
    };
  },
  methods: {
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      const params = {
        programaUniversidadId: this.form.id,
      };

      this.obtenerDatosConNotificacion(CostoProgramaService.findAll, 'items', this.nombreItem, params);

      this.item = null;
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await CostoProgramaService.remove(this.item.id);
      }

      return response;
    },
    confirmarAccionValidarCostosPrograma() {
      const costosProgramas = this.items
        .map((item) => /*html*/ `<li>${item.conceptoUniversidad.concepto.nombre}: ${item.monto}</li>`)
        .join('');

      this.confirmacion.titulo = 'Validar Costos Programa';
      this.confirmacion.mensaje = /*html*/ `¿Está seguro de validar los costos del programa?<ul>${costosProgramas}</ul>Al validar, no podrá realizar modificaciones en los costos del programa. También le permitirá realizar Solicitudes de Pago y Pagos (si el Programa Universidad está consolidado). ¿Desea continuar?`;
      this.confirmacion.realizandoAccion = false;
      this.confirmacion.fnAceptar = this.validarCostosPrograma;
      this.$refs.confirmacionRef.abrir();
    },
    async validarCostosPrograma() {
      this.validandoCostosPrograma = true;

      try {
        const { data } = await ProgramaUniversidadService.validarCostosPrograma(this.form.id);

        this.$refs.confirmacionRef.cerrar();
        this.$emit('actualizarListado');
        this.cerrar();
        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: data?.mensaje || 'Costos del programa validados correctamente',
          type: 'success',
        });
      } catch (error) {
        const data = error?.response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: this.nombreItem.toUpperCase(),
          text: mensaje || 'Error al validar costos del programa',
          type: 'error',
        });
      } finally {
        this.validandoCostosPrograma = false;
      }
    },
  },
};
</script>
